// jQuery
jQuery(function ($) {
  // -----------------------------
  // gnav
  // -----------------------------
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');

    var expanded = $(this).attr('aria-expanded') === "true";
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
    var hidden = $('.gnav').attr('aria-hidden') === "true";
    $('.gnav').attr('aria-hidden', !hidden);

    // トグルを開いていたら閉じる
    $('.search-toggle').removeClass('is-open');
    $('.translation-toggle').removeClass('is-open');

  });

  // メニュー内のリンクをクリックしたら閉じる
  $(document).on('click', '.gnav a', function () {
    $('.gnav').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
    $('.gnav').attr('aria-hidden', 'true');
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

  // -----------------------------
  // アコーディオン
  // -----------------------------
  $('.js-accordion').click(function () {   // アコーディオンメニュー全体
    $(this).next('.js-accordion-contents').slideToggle();   // 兄弟要素のアコーディオン内容を開閉
    $(this).toggleClass("is-open");   // メニューが開いたときのスタイル変化
  });

  // -----------------------------
  // トグル表示
  // -----------------------------
  const $searchBtn = $('.searchBtn');
  const $translationBtn = $('.translationBtn');
  const $searchToggle = $('.search-toggle');
  const $translationToggle = $('.translation-toggle');

  // 検索ボタンクリック
  $searchBtn.on('click', function () {
    // gnavを閉じる
    $('.gnav').removeClass('is-open').attr('aria-hidden', 'true');
    $('.gnavBtn').removeClass('is-open').attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く');

    // 翻訳を閉じて検索をトグル
    $translationToggle.removeClass('is-open');
    $searchToggle.toggleClass('is-open');
  });

  // 翻訳ボタンクリック
  $translationBtn.on('click', function () {
    // gnavを閉じる
    $('.gnav').removeClass('is-open').attr('aria-hidden', 'true');
    $('.gnavBtn').removeClass('is-open').attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く');

    // 検索を閉じて翻訳をトグル
    $searchToggle.removeClass('is-open');
    $translationToggle.toggleClass('is-open');
  });

  // -----------------------------
  // ctaボタン動き
  // -----------------------------
  $('.circleBtn').each(function () {
    const $btn = $(this);
    const $svg = $btn.find('.circle-borderAnim svg');
    const $circle = $btn.find('.circle-borderAnim circle');

    // 初期状態で非表示
    $svg.hide();

    $btn.on('mouseenter', function () {
      $btn.removeClass('is-animating-out').addClass('is-animating-in');
      $svg.show(); // 表示
    });

    $btn.on('mouseleave', function () {
      $btn.removeClass('is-animating-in').addClass('is-animating-out');

      // animationend を一度だけ検出
      $circle.one('animationend', function () {
        if ($btn.hasClass('is-animating-out')) {
          $svg.hide(); // 描画をOFF（完全非表示）
        }
      });
    });
  });

  // -----------------------------
  // タブ切り替え
  // -----------------------------
  $('.js-tab').on('click', function () {
    var idx = $('.js-tab').index(this);
    $(this).addClass('is-active').siblings('.js-tab').removeClass('is-active');

    var panelArea = $(this).closest('.js-tab_area').next('.js-panel_area');
    var panels = panelArea.find('.js-panel');
    panels.removeClass('is-active');
    panels.eq(idx).addClass('is-active');

    // URLクエリの更新は.section-search内だけで行う
    if ($(this).closest('.section-search').length > 0) {
      const tabMap = ['product', 'application', 'business'];
      const selectedTab = tabMap[idx];

      const url = new URL(window.location.href);
      url.searchParams.set('taxonomy_tab', selectedTab);
      url.hash = 'section-search'; // #section-searchに飛ぶ
      window.history.replaceState({}, '', url.toString());
    }
  });


  // ページ読み込み時に初期タブをアクティブに設定
  $(document).ready(function () {
    const url = new URL(window.location.href);
    const tabParam = url.searchParams.get('taxonomy_tab');

    const tabIndexMap = {
      product: 0,
      application: 1,
      business: 2,
    };

    // taxonomy_tab があるときはそのタブを選択
    if (tabParam && tabIndexMap.hasOwnProperty(tabParam)) {
      const idx = tabIndexMap[tabParam];
      $('.js-tab').eq(idx).click();
    } else {
      // taxonomy_tab が無い場合はデフォルトタブを選択（ただしURLは変えない）
      $('.js-tab').eq(0).addClass('is-active');
      $('.js-panel').eq(0).addClass('is-active');
    }
  });


  // -----------------------------
  // 絞り込み
  // -----------------------------

  $(function () {
    const path = window.location.pathname;

    // -----------------------------------------
    // productsページの場合
    // -----------------------------------------
    if (path.includes('/products')) {
      // タグクリックで選択トグル
      $('.tag-lists li').on('click', function () {
        $(this).toggleClass('selected');

        const url = new URL(window.location.href);

        const tabIndex = $('.js-tab').index($('.js-tab.is-active'));
        const tabMap = ['product', 'application', 'business'];
        const taxonomyMap = {
          product: 'product_category',
          application: 'application_category',
          business: 'business_category',
        };
        const paramMap = {
          product: 'product_tags',
          application: 'application_tags',
          business: 'business_tags',
        };

        const selectedTab = tabMap[tabIndex];
        const targetTaxonomy = taxonomyMap[selectedTab];
        const targetParam = paramMap[selectedTab];

        const selectedTags = [];
        $(`.tag-lists li.selected[data-taxonomy="${targetTaxonomy}"]`).each(function () {
          selectedTags.push($(this).data('slug'));
        });

        const pathParts = url.pathname.split('/');
        const pageIndex = pathParts.indexOf('page');
        if (pageIndex !== -1) {
          pathParts.splice(pageIndex, 2);
          url.pathname = pathParts.join('/');
        }

        url.searchParams.set('taxonomy_tab', selectedTab);
        if (selectedTags.length > 0) {
          url.searchParams.set(targetParam, selectedTags.join(','));
        } else {
          url.searchParams.delete(targetParam);
        }

        Object.entries(paramMap).forEach(([key, param]) => {
          if (key !== selectedTab) {
            url.searchParams.delete(param);
          }
        });

        url.searchParams.delete('paged');
        url.hash = 'section-search';

        window.location.href = url.toString();
      });

      // リセットボタン
      $('.reset-btn').on('click', function () {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');
        const pageIndex = pathParts.indexOf('page');
        if (pageIndex !== -1) {
          pathParts.splice(pageIndex, 2);
          url.pathname = pathParts.join('/');
        }

        url.searchParams.delete('product_tags');
        url.searchParams.delete('application_tags');
        url.searchParams.delete('business_tags');
        url.searchParams.delete('paged');

        url.hash = 'section-search';
        window.location.href = url.toString();
      });

      // テキスト制御
      function adjustUserVoiceText() {
        var isSP = $(window).width() < 768;
        var limit = isSP ? 50 : 84;

        $('.user-voice__text').each(function () {
          var $this = $(this);
          var fullText = $this.data('fulltext');

          if (fullText.length > limit) {
            $this.text(fullText.substring(0, limit) + '…');
          } else {
            $this.text(fullText);
          }
        });
      }

      adjustUserVoiceText();
      $(window).on('resize', adjustUserVoiceText);
    }

    // -----------------------------------------
    // case-studiesページの場合
    // -----------------------------------------
    if (path.includes('/case-studies')) {
      // タグクリックで選択トグル
      $('.tag-lists li').on('click', function () {
        $(this).toggleClass('selected');

        const url = new URL(window.location.href);

        const tabIndex = $('.js-tab').index($('.js-tab.is-active'));
        const tabMap = ['product', 'application', 'business'];
        const taxonomyMap = {
          product: 'voice_product_category',
          application: 'voice_application_category',
          business: 'industry_category',
        };
        const paramMap = {
          product: 'product_tags',
          application: 'application_tags',
          business: 'business_tags',
        };

        const selectedTab = tabMap[tabIndex];
        const targetTaxonomy = taxonomyMap[selectedTab];
        const targetParam = paramMap[selectedTab];

        const selectedTags = [];
        $(`.tag-lists li.selected[data-taxonomy="${targetTaxonomy}"]`).each(function () {
          selectedTags.push($(this).data('slug'));
        });

        const pathParts = url.pathname.split('/');
        const pageIndex = pathParts.indexOf('page');
        if (pageIndex !== -1) {
          pathParts.splice(pageIndex, 2);
          url.pathname = pathParts.join('/');
        }

        url.searchParams.set('taxonomy_tab', selectedTab);
        if (selectedTags.length > 0) {
          url.searchParams.set(targetParam, selectedTags.join(','));
        } else {
          url.searchParams.delete(targetParam);
        }

        Object.entries(paramMap).forEach(([key, param]) => {
          if (key !== selectedTab) {
            url.searchParams.delete(param);
          }
        });

        url.searchParams.delete('paged');
        url.hash = 'section-search';

        window.location.href = url.toString();
      });

      // リセットボタン
      $('.reset-btn').on('click', function () {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');
        const pageIndex = pathParts.indexOf('page');
        if (pageIndex !== -1) {
          pathParts.splice(pageIndex, 2);
          url.pathname = pathParts.join('/');
        }

        url.searchParams.delete('product_tags');
        url.searchParams.delete('application_tags');
        url.searchParams.delete('business_tags');
        url.searchParams.delete('paged');

        url.hash = 'section-search';
        window.location.href = url.toString();
      });
    }
  });

  // ----------------------------------
  // 数字でわかる日本海化 アニメーション
  // ----------------------------------
  $(document).ready(function () {
    const thresholdOffset = 0.2;  // 20% 表示された時にアニメーション開始

    $(window).on("scroll", function () {
      $(".anim-bg").each(function () {
        const elementTop = $(this).offset().top;
        const elementHeight = $(this).outerHeight();
        const windowHeight = $(window).height();
        const scrollTop = $(window).scrollTop();

        // 要素が画面内に20%以上表示されたらアニメーション開始
        if (scrollTop + windowHeight * (1 - thresholdOffset) > elementTop + elementHeight * thresholdOffset) {
          $(this).addClass("is-active");
        }
      });
    });

    // ページ読み込み時にもチェック
    $(window).trigger("scroll");
  });


  // ----------------------------------
  // cta-recruit リンク先設定
  // ----------------------------------

  // クエリパラメータを取得
  const queryParams = new URLSearchParams(window.location.search);
  const inquiryType = queryParams.get("type");

  // "career" が指定されている場合
  if (inquiryType === "career") {
    const $careerOption = $("input[name='inquiry-type'][value='採用について']");

    if ($careerOption.length) {
      // ラジオボタンを選択状態に
      $careerOption.prop("checked", true);

      // 親のラベル要素に "checked" クラスを追加
      $careerOption.closest("label").addClass("checked");

      // 採用についての選択肢を表示
      $careerOption.trigger("change");
    }
  }


  const $form = $('.wpcf7 form');
  const $checkbox = $form.find('input[type="checkbox"].privacy-check');
  const $message = $('.acceptance-message');
  const $submitBtn = $form.find('input[type="submit"]');

  function getVisibleRequiredFields() {
    return $form.find('[aria-required="true"]').filter(function () {
      return $(this).is(':visible');
    });
  }

  function toggleMessageAndButton() {
    let hasEmpty = false;

    getVisibleRequiredFields().each(function () {
      const $field = $(this);
      const type = $field.attr('type');
      const tag = $field.prop('tagName').toLowerCase();

      if (type === 'radio' || type === 'checkbox') {
        const name = $field.attr('name');
        if (!$form.find(`[name="${name}"]:checked`).length) {
          hasEmpty = true;
        }
      } else if (tag === 'input' || tag === 'textarea') {
        if (!$field.val().trim()) {
          hasEmpty = true;
        }
      }
    });

    if ($checkbox.length && !$checkbox.is(':checked')) {
      hasEmpty = true;
    }

    // メッセージ表示/非表示
    $message.toggle(hasEmpty);

    // ボタン制御
    $submitBtn.prop('disabled', hasEmpty);
  }

  // 初期チェック
  toggleMessageAndButton();

  // イベントバインド
  $form.on('input change', toggleMessageAndButton);
});

// JavaScript
// -----------------------------
// BUSINESS ホバー動き
// -----------------------------
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.business-content__list li');
  const bgImages = document.querySelectorAll('.business-content__bg__img');
  const allBgs = document.querySelectorAll('.business-content__list .bg');

  items.forEach((item) => {
    const type = item.dataset.business;
    const targetImg = document.querySelector(`.business-content__bg__img._${type}`);

    item.addEventListener('mouseenter', () => {
      // 全背景画像を非表示
      bgImages.forEach(img => img.style.opacity = 0);

      // 該当背景画像だけ表示
      if (targetImg) targetImg.style.opacity = 1;

      // すべての .bg を非表示（自分自身も含む）
      allBgs.forEach(bg => bg.style.opacity = 0);
    });

    item.addEventListener('mouseleave', () => {
      // 背景画像を非表示に戻す
      if (targetImg) targetImg.style.opacity = 0;

      // すべての .bg を元に戻す
      allBgs.forEach(bg => bg.style.opacity = 1);
    });
  });
});


// -----------------------------------------
// フェードアニメーション
// -----------------------------------------
function showElementAnimation() {

  var element = document.getElementsByClassName('js-animation');
  if (!element) return; // 要素がなかったら処理をキャンセル

  var showTiming = window.innerHeight > 768 ? 300 : 40; // 要素が出てくるタイミングはここで調整
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;

  for (var i = 0; i < element.length; i++) {
    var elemClientRect = element[i].getBoundingClientRect();
    var elemY = scrollY + elemClientRect.top;
    if (scrollY + windowH - showTiming > elemY) {
      element[i].classList.add('is-show');
    }
  }
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);



